exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-width[data-v-48b16b8d] {\r\n    width: 70%;\n}\n[data-v-48b16b8d] .country-tabs .el-tabs__header {\r\n    margin-left: 30px;\r\n    margin-right: 30px;\n}\n.valid-data-form-item[data-v-48b16b8d] {\r\n    margin-left: 70px;\r\n    margin-right: 25%;\r\n    border: 1px solid black;\r\n    background-color: gainsboro;\n}\n.margin-5[data-v-48b16b8d] {\r\n    margin-left: 5px;\n}\n.margin-10[data-v-48b16b8d] {\r\n    margin-left: 10px;\n}\r\n", ""]);

// exports
